import type { CSSProperties } from "react";
import { getFriendlyErrorMessage } from "@/lib/api-client";

export interface CanvasStatePlaceholderProps {
  height: number | string;
  variant: "loading" | "error";
  error?: unknown;
}

export function CanvasStatePlaceholder({ height, variant, error }: CanvasStatePlaceholderProps) {
  const styleVar = {
    "--canvas-h": typeof height === "number" ? `${height}px` : height,
  } as CSSProperties;

  if (variant === "loading") {
    return (
      <div
        className="flex h-[var(--canvas-h)] items-center justify-center rounded-md border bg-card text-sm text-muted-foreground"
        style={styleVar}
      >
        Carregando canvas…
      </div>
    );
  }
  return (
    <div
      className="flex h-[var(--canvas-h)] items-center justify-center rounded-md border border-destructive/30 bg-destructive/5 px-4 text-sm text-destructive"
      style={styleVar}
    >
      {getFriendlyErrorMessage(error, "Erro ao carregar o fluxo da linha.")}
    </div>
  );
}
